import PurchaseOrderItemDetail from "@/classes/component-classes/PurchaseOrderItemDetail";

export default class PurchaseOrderItemDetailExtended extends PurchaseOrderItemDetail{

    constructor() {

        super();

        this.rowId = '';
        this.readOnly = false;
        this.showAddButton = true;
        this.isEditing = false;
        this.isDeleting = false;
    }
}
